import Vue from "vue";
import http from "../api/http";
export default {
  //rsa加密
  getPublicKey() {
    return http.post("api/os/createPublicKey", {}, false);
  },
  //rsa加密
  async RsaPassWord(password) {
    let publicResult = await this.getPublicKey();
    let RsaId = publicResult.data.id;
    let publicKey = publicResult.data.publicKey;
    let NewPwd = Vue.prototype.$encryptedData(publicKey, password);
    return { RsaId, NewPwd };
  }
};



// WEBPACK FOOTER //
// ./src/utilities/RsaPassWord.js